<template>
  <main>
    <DetailHeader />
    <slot />
  </main>
</template>

<script>
import DetailHeader from '~/components/header/DetailHeader.vue'

export default {
  name: 'detail',
  components: {
    DetailHeader
  }
}
</script>

<style scoped></style>
